<template>
  <div>
    <div v-if="isActionsEnabled" class="actions-layout">
      <horizontal-link-menu :items="bulkActions" @action="bulkActionSelected">
        <template #corner>
          <checkbox :checked="positions && positions.length === selected.size && selected.size > 0" @change="checkboxAll"/>
        </template>
      </horizontal-link-menu>
      <!--
      Раскомментить когда реалзуем в АПИ ТПРО2 поиск по справочнику номенклатуры
      <online-search
        :searchFunction="searchProduct"
        @selected="createPosition"
        placeholder="добавить позицию из общего каталога товаров..."
        bg="dark"
      />
      -->
    </div>
    <div v-else class="search-layout mb2">
      <search placeholder="поиск позиций..." @search="runSearch" @reset="resetSearch" bg="dark"/>
    </div>
    <div>
      <div class="relative pb3">
        <div v-if="anOperationInProgress" class="absolute w-100 h-100 bg-white o-80 loading-positions-spinner-layout">
          <content-spinner/>
        </div>
        <positions :positions="positions"
          :actions="actions"
          :selected="selected"
          @edit="editPosition"
          @delete="deletePosition"
          @checkboxed="checkboxPosition"
        />
      </div>
      <div class="pv3 flex justify-center bg-ligh" v-if="totalCount > limit">
        <paginator :page="page" :total="pageCount" :routing="false" @goto="switchPage"/>
      </div>
    </div>
    <modal :show="positionForm" @close="closeModal" :transparent="true">
      <on-click-outside @outside="closeModal">
        <position-form
          :context="positionForm"
          @canceled="closeModal"
          @submitted="positionFormSubmited"
        />
      </on-click-outside>
    </modal>
  </div>
</template>

<script>
import ContentSpinner from '@/components/ui/progress/ContentSpinner.vue'
import HorizontalLinkMenu from '@/components/common/HorizontalLinkMenu.vue'
import Checkbox from '@/components/ui/Checkbox.vue'
import Modal from '@/components/modal/Modal.vue'
import OnClickOutside from '@/components/ui/OnClickOutside.vue'
import OnlineSearch from '@/components/ui/OnlineSearch.vue'
import Positions from './Positions.vue'
import PositionForm from './PositionForm.vue'
import Paginator from '@/components/Paginator.vue'
import Search from '@/components/common/Search.vue'

import { DataService } from '@/services/DataService.js'

import { mapGetters } from 'vuex'

export default {
  props: ['id', 'out', 'state', 'actors'],
  components: {
    ContentSpinner,
    HorizontalLinkMenu,
    Checkbox,
    Modal,
    OnClickOutside,
    OnlineSearch,
    Positions,
    PositionForm,
    Paginator,
    Search
  },
  computed: {
    ...mapGetters('product', ['product']),
    statusCode () {
      return this.state.status_code.value
    },
    pageCount () {
      return this.calcPageCount(this.totalCount, this.limit)
    },
    apiParams () {
      return {
        filter: { title: this.searchPositionFilter },
        offset: (this.page - 1) * this.limit,
        limit: this.limit
      }
    },
    bulkActions () {
      var actions = []
      if (this.actors.loadPositionsFromFile) {
        actions.push({
          title: this.actors.loadPositionsFromFile.title,
          callback: this.actors.loadPositionsFromFile.callback,
          enabled: true,
          userConfirmation: null,
          reloadRequired: true
        })
      }
      if (this.actors.downloadTemplate) {
        actions.push({
          title: this.actors.downloadTemplate.title,
          callback: this.actors.downloadTemplate.callback,
          enabled: true,
          userConfirmation: null
        })
      }
      if (this.actors.appendParentPositions) {
        actions.push({
          title: this.actors.appendParentPositions.title,
          callback: this.actors.appendParentPositions.callback,
          enabled: this.actors.appendParentPositions.enabled(this.actions, this.positions),
          userConfirmation: null,
          reloadRequired: true
        })
      }
      if (this.actors.removeSelectedPositions) {
        actions.push({
          title: this.actors.removeSelectedPositions.title,
          callback: this.actors.removeSelectedPositions.callback,
          enabled: this.actors.removeSelectedPositions.enabled(this.actions, this.selected),
          userConfirmation: 'Вы действительно хотите удалите выделенные позиции?',
          reloadRequired: true
        })
      }
      if (this.actors.removeAllPositions) {
        actions.push({
          title: this.actors.removeAllPositions.title,
          callback: this.actors.removeAllPositions.callback,
          enabled: this.actors.removeAllPositions.enabled(this.actions, this.positions),
          userConfirmation: 'Вы действительно хотите удалите все позиции?',
          reloadRequired: true
        })
      }
      return actions
    },
    isActionsEnabled () {
      return this.actions && (this.actions.create || this.actions.delete)
    }
  },
  watch: {
    apiParams: {
      immediate: true,
      handler: function (p) {
        return this.loadPositions(p)
      }
    },
    isActionsEnabled (v, o, l) {
      if (v) {
        // если редактирование доступно то отчищаем фильтр поиска позиции по названию
        this.searchPositionFilter = null
      }
    },
    statusCode: {
      immediate: false,
      handler: function (s) {
        return this.reloadPositionsPage()
      }
    }
  },
  data () {
    return {
      page: 1,
      limit: 20,
      totalCount: 0,
      positions: [],
      actions: null,
      positionForm: null,
      anOperationInProgress: false,
      searchPositionFilter: null,
      searchProduct: function (value) {
        const params = {
          filter: { name: value },
          offset: 0,
          limit: 50
        }
        return DataService.getProducts(params)
          .then(({ data: { product: { data, totalCount } } }) => {
            return {
              items: data ? data.map(p => ({ id: p.id, name: p.name })) : []
            }
          })
      },
      selected: new Set([])
    }
  },
  methods: {
    calcPageCount (totalCount, limit) {
      return totalCount % limit
        ? Math.floor(totalCount / limit) + 1
        : totalCount / limit
    },
    switchPage ({ query: { page } }) {
      if (this.anOperationInProgress) return
      this.page = page
    },
    async loadPositionsPage (page) {
      this.page = page
      this.loadPositions(this.apiParams)
    },
    async reloadPositionsPage () {
      return this.loadPositions(this.apiParams)
    },
    async loadPositions (params) {
      this.anOperationInProgress = true
      this.actors.loadPositions.callback(params)
        .then(({ positions, totalCount, actions }) => {
          this.positions = this.$lo.cloneDeep(positions) // чтобы можно было добавить флажок selected, иначе positions readonly
          this.totalCount = totalCount
          this.actions = actions
          this.selected = new Set([])
        })
        .finally(() => {
          this.anOperationInProgress = false
        })
    },
    bulkActionSelected (action) {
      if (action.userConfirmation && !confirm(action.userConfirmation)) {
        return
      }
      this.anOperationInProgress = true
      action.callback(this)
        .catch((error) => {
          console.error(`[${action.title} error]: ${error}`)
        })
        .finally(() => {
          this.anOperationInProgress = false
          if (action.reloadRequired) {
            this.reloadPositionsPage()
          }
        })
    },
    closeModal () {
      this.positionForm = null
    },
    // из online-search по товарам.. нашли товар и дергаем это для того чтобы создать позицию
    createPosition ({ id, name }) {
      this.positionForm = {
        position: this.actors.createPosition.makeDraft({ id, name }),
        callback: this.actors.createPosition.callback,
        mode: 'create'
      }
    },
    // из positions (списка позиций)
    editPosition (position) {
      this.positionForm = {
        position: position,
        callback: this.actors.updatePosition.callback,
        mode: 'edit'
      }
    },
    // из positions (списка позиций)
    deletePosition (position) {
      if (!confirm('Удалить позицию?')) {
        return
      }
      this.anOperationInProgress = true
      this.actors.deletePosition.callback({ id: position.id })
        .then((r) => {
          this.positionDeleted(position.id)
        })
        .catch((e) => {
          console.error(`[Delete position error]: ${e}`)
        })
        .finally(() => {
          this.anOperationInProgress = false
        })
    },
    // из position-form
    positionFormSubmited () {
      this.positionForm = null
      this.reloadPositionsPage()
    },
    // из метода deletePosition
    positionDeleted (id) {
      var page = this.page
      const totalPages = this.calcPageCount(this.totalCount - 1, this.limit)
      if (page > totalPages) {
        this.loadPositionsPage(totalPages || 1)
      } else {
        this.loadPositions(this.apiParams)
      }
    },
    runSearch (s) {
      this.searchPositionFilter = s
      this.loadPositionsPage(1)
    },
    resetSearch () {
      this.searchPositionFilter = null
      this.loadPositionsPage(1)
    },
    // checkboxing
    checkboxAll ({ checked }) {
      if (checked) {
        this.selected = new Set(this.positions.map((p) => p.id))
      } else {
        this.selected = new Set([])
      }
    },
    checkboxPosition ({ value, checked }) {
      if (checked) {
        this.selected.add(+value)
      } else {
        this.selected.delete(+value)
      }
      // реактивность....
      this.selected = new Set(this.selected)
    }
  }
}
</script>

<style lang="scss" scoped>
.nomenclature-details {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 16px;
}
.card-sublist {
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 0rem;
  grid-row-gap: 0.5rem;
}
.contract-position-layout {
  display: grid;
  grid-template-columns: 30px auto 120px 40px;
  grid-column-gap: .5rem;
  grid-row-gap: .5rem;
  align-items: center;
}
.product-parameters-layout {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto;
  grid-column-gap: .5rem;
  grid-row-gap: 1rem;
  align-items: center;
}
.header-delimeter {
  border-top-style: solid;
  border-top-width: .15rem;
  border-color: #F0F4F8;
}
.search-layout {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto;
  grid-column-gap: .5rem;
  align-items: center;
}
.loading-positions-spinner-layout{
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto;
  align-items: center;
  justify-items: center;
}
</style>
